const getters = {
    getMockCompanyID: state => state.MockCompanyID,
    getCompaniesForMocking: state => state.companies,
    getMockedCompany: (state) => {
        return state.companies.filter((company) => {
            return company.id == state.MockCompanyID
        })[0]
    },
    getExpandAll: (state) => {
        return state.expandAll;
    }
}

export default getters
